import script from "./ScrollerManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollerManager.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollerManager.vue?vue&type=style&index=0&id=182c41c9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182c41c9"]])

export default __exports__